const ScanCodeActionTypes = {
  SCAN_CODE: 'SCAN_CODE',
};

export default ScanCodeActionTypes;
